import { requestLogout } from "@state/auth/AuthEffects";
import {
  authenticationContextEvent,
  clearUser,
  deleteUserPicture,
  logout,
  setCertificateInfosPhone,
  setCertificateStatus,
  setEmailAndLastnameAndFirstname,
  setOfficeAlias,
  setOnboardingError,
  setOnboardingToFalse,
  setUser,
  updateSelectedOfficeIds,
} from "@state/auth/AuthEvents";
import { ActiveUser, AuthenticationContext } from "@type/core/auth/auth.types";
import logger from "@utils/logger";
import { createStore } from "effector";

export const authenticationStore = createStore<AuthenticationContext | null>(
  null,
)
  .on(authenticationContextEvent, (_, payload) => {
    return payload === undefined
      ? null
      : {
          ...payload,
        };
  })
  .on<ActiveUser>(
    setUser,
    (state, payload: ActiveUser): AuthenticationContext => {
      const currentRights = state?.user?.rights ?? [];
      if (payload.groups && payload.groups.length > 0) {
        currentRights.push("GESTION_GROUPES");
      }
      const flattenRightsWithoutDoublon = [
        ...new Set([
          ...currentRights,
          ...payload.offices.flatMap((o) => o.rights ?? []),
        ]),
      ];
      return {
        ...state,
        user: { ...payload, rights: flattenRightsWithoutDoublon },
      };
    },
  )
  .on(clearUser, () => null)
  .on(updateSelectedOfficeIds, (state, payload) => {
    const flattenRightsWithoutDoublon = [
      ...new Set([
        ...(state?.user?.rights ?? []),
        ...payload.flatMap((o) => o.rights),
      ]),
    ];
    return {
      ...state,
      selectedOfficeIds: payload.map((office) => office.id),
      rights: flattenRightsWithoutDoublon,
    };
  })
  .on(setOnboardingToFalse, (state) => ({
    ...state,
    user:
      state && state.user
        ? {
            ...state.user,
            onboarding: false,
          }
        : undefined,
  }))
  .on(setOnboardingError, (state, payload) => ({
    ...state,
    user:
      state && state.user
        ? {
            ...state.user,
            onboardingError: payload,
          }
        : undefined,
  }))
  .on(setCertificateInfosPhone, (state, payload) => ({
    ...state,
    user:
      state && state.user
        ? {
            ...state.user,
            certificateInfos: {
              ...state.user.certificateInfos,
              phone: payload,
            },
          }
        : undefined,
  }))
  .on(setCertificateStatus, (state, payload) => ({
    ...state,
    user:
      state && state.user
        ? {
            ...state.user,
            tsCertificateStatus: payload,
          }
        : undefined,
  }))
  .on(setEmailAndLastnameAndFirstname, (state, payload) => ({
    ...state,
    user:
      state && state.user
        ? {
            ...state.user,
            email: payload.email,
            lastname: payload.lastname,
            firstname: payload.firstname,
          }
        : undefined,
  }))
  .on(setOfficeAlias, (state, payload) => ({
    ...state,
    user:
      state && state.user
        ? {
            ...state.user,
            offices: state.user.offices.map((office) =>
              office.id === payload.id
                ? { ...office, alias: payload.newAlias }
                : office,
            ),
          }
        : undefined,
  }))
  .on(deleteUserPicture, (state) => ({
    ...state,
    user:
      state && state.user
        ? {
            ...state.user,
            picture: [],
          }
        : undefined,
  }));

logout.watch(() => {
  void requestLogout({})
    .then((response) => {
      if (response.ok) {
        localStorage.clear();
        sessionStorage.clear();
        clearUser();
      }
    })
    .catch((err) => {
      logger.error(err);
    });
});
